module.exports = __webpack_public_path__ + "img/bannerKoner-KB-web-entradas-512x723_eus.95c696f6.jpg";